export default __webpack_public_path__ + "static/about-26694440b9d71a97af0705cc49d140d3.jpg";